module.exports = __webpack_public_path__ + "img/ptu-logo.6b047ab3.png";